// extracted by mini-css-extract-plugin
export var errorIcon = "_na-1";
export var nameLogo = "_na-0";